import React from 'react'
import { UpgradePromotionBoxCopy } from '@chegg-wt/core/types/copy'
import { Resource } from '@chegg-wt/core/types/core'
import { LvpMarginWrapper } from '../Layouts/LargeVideoPlayerLayout'
import UpgradePromotionBox from '../UpgradePromotionBox'

import * as Styled from './styled'

interface Props {
  copy: Resource[]
  title?: string
  upgradePromotionCopy?: UpgradePromotionBoxCopy
}

const Resources: React.FunctionComponent<Props> = ({
  copy,
  title,
  upgradePromotionCopy,
}: Props) => (
  <Styled.Container>
    <LvpMarginWrapper>
      <Styled.Wrapper>
        {upgradePromotionCopy && (
          <Styled.Card>
            <UpgradePromotionBox {...{ ...upgradePromotionCopy, homePage: true }} />
          </Styled.Card>
        )}
        <Styled.Header>{title}</Styled.Header>
        {copy.map(({ header, url, summary, seoLinks, dataTestId }) => (
          <Styled.Card key={header} data-test={dataTestId}>
            {url ? (
              <Styled.CartTitleLinkHeader>
                <Styled.CardTitleLink href={url}>{header}</Styled.CardTitleLink>
              </Styled.CartTitleLinkHeader>
            ) : (
              <Styled.CardTitleHeader>{header}</Styled.CardTitleHeader>
            )}
            <Styled.CardText>{summary}</Styled.CardText>
            {seoLinks?.length > 0 ? (
              <p>
                {seoLinks.map(({ children, href }, i) => (
                  <>
                    {i > 0 ? ' | ' : ''} <a href={href}>{children}</a>
                  </>
                ))}
              </p>
            ) : null}
          </Styled.Card>
        ))}
      </Styled.Wrapper>
    </LvpMarginWrapper>
  </Styled.Container>
)

export default Resources
